/** @type {Record<string, Record<string, string>>} */
export const profileUi = {
  title: {
    en: 'Profile settings',
    ru: 'Настройки профиля',
    es: 'Configuración del perfil',
    fr: 'Paramètres du profil',
    zh: '个人资料设置',
    hi: 'प्रोफ़ाइल सेटिंग्स',
  },
  back: {
    en: '← Back',
    ru: '← Назад',
    es: '← Volver',
    fr: '← Retour',
    zh: '← 返回',
    hi: '← वापस',
  },
  role: {
    en: 'Role',
    ru: 'Роль',
    es: 'Rol',
    fr: 'Rôle',
    zh: '角色',
    hi: 'भूमिका',
  },
  organization: {
    en: 'Organization',
    ru: 'Организация',
    es: 'Organización',
    fr: 'Organisation',
    zh: '组织',
    hi: 'संगठन',
  },
  client: {
    en: 'Client',
    ru: 'Клиент',
    es: 'Cliente',
    fr: 'Client',
    zh: '客户',
    hi: 'ग्राहक',
  },
  emailVerified: {
    en: 'Email verified',
    ru: 'Email подтверждён',
    es: 'Correo verificado',
    fr: 'E-mail vérifié',
    zh: '邮箱已验证',
    hi: 'ईमेल सत्यापित',
  },
  markVerified: {
    en: 'Mark email verified',
    ru: 'Отметить email подтверждённым',
    es: 'Marcar correo como verificado',
    fr: 'Marquer l’e-mail comme vérifié',
    zh: '标记邮箱已验证',
    hi: 'ईमेल सत्यापित चिह्नित करें',
  },
  details: {
    en: 'Details',
    ru: 'Данные',
    es: 'Datos',
    fr: 'Coordonnées',
    zh: '基本信息',
    hi: 'विवरण',
  },
  name: {
    en: 'Name',
    ru: 'Имя',
    es: 'Nombre',
    fr: 'Nom',
    zh: '姓名',
    hi: 'नाम',
  },
  email: {
    en: 'Email',
    ru: 'Email',
    es: 'Correo',
    fr: 'E-mail',
    zh: '邮箱',
    hi: 'ईमेल',
  },
  language: {
    en: 'Interface language',
    ru: 'Язык интерфейса',
    es: 'Idioma de la interfaz',
    fr: 'Langue de l’interface',
    zh: '界面语言',
    hi: 'इंटरफ़ेस भाषा',
  },
  languageHint: {
    en: 'Used for guided tours and localized messages. Default is English.',
    ru: 'Для обучения и локализованных сообщений. По умолчанию — английский.',
    es: 'Para tours guiados y mensajes localizados. El predeterminado es inglés.',
    fr: 'Pour les visites guidées et les messages localisés. L’anglais par défaut.',
    zh: '用于引导教程和本地化消息。默认为英语。',
    hi: 'गाइडेड टूर और स्थानीय संदेशों के लिए। डिफ़ॉल्ट अंग्रेज़ी।',
  },
  onboardingEnabled: {
    en: 'Interactive tour prompts',
    ru: 'Подсказки обучения',
    es: 'Avisos del tour interactivo',
    fr: 'Invitations à la visite guidée',
    zh: '互动导览提示',
    hi: 'इंटरैक्टिव टूर संकेत',
  },
  onboardingEnabledHint: {
    en: 'Show welcome tour offers when you open new pages. You can always start a tour with the ? Tour button.',
    ru: 'Показывать предложения обучения на новых страницах. Запустить вручную можно кнопкой «? Обучение».',
    es: 'Mostrar invitaciones al tour en páginas nuevas. Siempre puede iniciarlo con el botón ? Tour.',
    fr: 'Afficher les invitations au tour sur les nouvelles pages. Lancez-le avec le bouton ? Tour.',
    zh: '打开新页面时显示导览邀请。可随时用 ? 导览 按钮手动开始。',
    hi: 'नए पेज पर टूर के सुझाव दिखाएँ। ? टूर बटन से कभी भी शुरू करें।',
  },
  saveProfile: {
    en: 'Save profile',
    ru: 'Сохранить профиль',
    es: 'Guardar perfil',
    fr: 'Enregistrer le profil',
    zh: '保存资料',
    hi: 'प्रोफ़ाइल सहेजें',
  },
  changePassword: {
    en: 'Change password',
    ru: 'Сменить пароль',
    es: 'Cambiar contraseña',
    fr: 'Changer le mot de passe',
    zh: '更改密码',
    hi: 'पासवर्ड बदलें',
  },
  currentPassword: {
    en: 'Current password',
    ru: 'Текущий пароль',
    es: 'Contraseña actual',
    fr: 'Mot de passe actuel',
    zh: '当前密码',
    hi: 'वर्तमान पासवर्ड',
  },
  newPassword: {
    en: 'New password',
    ru: 'Новый пароль',
    es: 'Nueva contraseña',
    fr: 'Nouveau mot de passe',
    zh: '新密码',
    hi: 'नया पासवर्ड',
  },
  confirmPassword: {
    en: 'Confirm',
    ru: 'Подтверждение',
    es: 'Confirmar',
    fr: 'Confirmer',
    zh: '确认',
    hi: 'पुष्टि',
  },
  updatePassword: {
    en: 'Update password',
    ru: 'Обновить пароль',
    es: 'Actualizar contraseña',
    fr: 'Mettre à jour le mot de passe',
    zh: '更新密码',
    hi: 'पासवर्ड अपडेट करें',
  },
  profileUpdated: {
    en: 'Profile updated.',
    ru: 'Профиль обновлён.',
    es: 'Perfil actualizado.',
    fr: 'Profil mis à jour.',
    zh: '资料已更新。',
    hi: 'प्रोफ़ाइल अपडेट हो गई।',
  },
  passwordChanged: {
    en: 'Password changed.',
    ru: 'Пароль изменён.',
    es: 'Contraseña cambiada.',
    fr: 'Mot de passe modifié.',
    zh: '密码已更改。',
    hi: 'पासवर्ड बदल गया।',
  },
  emailSignature: {
    en: 'Email signature',
    ru: 'Подпись письма',
    es: 'Firma de correo',
    fr: 'Signature d’e-mail',
    zh: '邮件签名',
    hi: 'ईमेल हस्ताक्षर',
  },
  emailSignatureHint: {
    en: 'Added to new messages and replies from your Outlook mailbox.',
    ru: 'Добавляется к новым письмам и ответам из вашего ящика Outlook.',
    es: 'Se añade a los mensajes nuevos y a las respuestas de su buzón de Outlook.',
    fr: 'Ajoutée aux nouveaux messages et aux réponses de votre boîte Outlook.',
    zh: '会加到您 Outlook 邮箱发出的新邮件和回复中。',
    hi: 'आपके Outlook मेलबॉक्स से नए संदेशों और जवाबों में जुड़ता है।',
  },
  emailMarkedVerified: {
    en: 'Email marked verified.',
    ru: 'Email отмечен как подтверждённый.',
    es: 'Correo marcado como verificado.',
    fr: 'E-mail marqué comme vérifié.',
    zh: '邮箱已标记为已验证。',
    hi: 'ईमेल सत्यापित चिह्नित किया गया।',
  },
};
